module.exports = __webpack_public_path__ + "static/img/china-3.ff258b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/china/china-3.png
// module id = 1385
// module chunks = 1